var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.50012C11.802 6.50012 6.5 11.7441 6.5 17.7605C6.5 23.7768 11.802 29.0209 18 29.0209C24.198 29.0209 29.5 23.7768 29.5 17.7605C29.5 11.7441 24.198 6.50012 18 6.50012ZM3.5 17.7605C3.5 10.0349 10.198 3.50012 18 3.50012C25.802 3.50012 32.5 10.0349 32.5 17.7605C32.5 21.3361 31.0652 24.6567 28.7503 27.1923L36.0508 34.3582C36.642 34.9385 36.6508 35.8882 36.0705 36.4794C35.4902 37.0707 34.5405 37.0795 33.9493 36.4992L26.5119 29.1989C24.0955 30.9644 21.137 32.0209 18 32.0209C10.198 32.0209 3.5 25.4861 3.5 17.7605Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.23c5892ad5530676b7638091efc23df1.svg";
export { ForwardRef as ReactComponent };